export default __webpack_public_path__ + "static/media/Contrato_NewERP.ab6ad1e4.pdf";